module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00490.96c31573.jpg";